import * as api from '../api';
import { END_LOADING, END_LOADING_PROFILE, END_LOADING_USER_POSTS, FETCH_FOLLOWERS, FETCH_FOLLOWING, FETCH_MORE_USER_POSTS, FETCH_PROFILE, FETCH_SUGGESTED_USERS, FETCH_USER_POSTS, FOLLOW_USER, SEARCH_USERS, START_LOADING, START_LOADING_PROFILE, START_LOADING_USER_POSTS, UNFOLLOW_USER } from '../constants/actionTypes';

//search users
export const searchUsers = (inputData, cb) => async (dispatch) => {

    let error = null; 
    let res = null;

    try {

        const {data: { data } } = await api.searchUsers(inputData);

        dispatch({
            type: SEARCH_USERS,
            payload: data
        });


        res = data; 


    } catch (err) {

        console.log(err);

        error = err
    }

    if(typeof cb === 'function'){

        cb(error, res);
    }
}

//getUserProfile
export const getUserProfile = (id, invokingID = 'none') => async (dispatch) => {

    try {

        dispatch({
            type: START_LOADING_PROFILE,
            payload: {}
        });

        const { data } = await api.fetchProfile(id, invokingID);

        const actionType = FETCH_PROFILE; 

        dispatch({
            type: actionType,
            payload: data
        });

        dispatch({
            type: END_LOADING_PROFILE,
            payload: {}
        });

    } catch (error) {

        console.log(error);
    }

}


//getUserPosts
export const getUserPosts = (id, page=1, append=false) => async (dispatch) => {

    try {

        dispatch({
            type: START_LOADING_USER_POSTS
        });

        const { data } = await api.fetchUserPosts(id, page);

        const actionType = append === true && page !== 1 ? FETCH_MORE_USER_POSTS : FETCH_USER_POSTS; 

        dispatch({
            type: actionType,
            payload: data
        });

        dispatch({
            type: END_LOADING_USER_POSTS
        });

    }catch (error) {

        console.log(error);
    }

    
}

//follow user
export const followUser = (invokingId, id) => async (dispatch) => {

    try {

        const { data } = await api.followUser(invokingId, id);

        dispatch({
            type: FOLLOW_USER,
            payload: data
        });

    }catch (error) {

        console.log(error);
    }

    
}

export const unFollowUser = (invokingId, id) => async (dispatch) => {

    try {

        const { data } = await api.unFollowUser(invokingId, id);

        dispatch({
            type: UNFOLLOW_USER,
            payload: data
        });

    }catch (error) {

        console.log(error);
    }

    
}

//fetch user followers
export const getUserFollowers = (id=null, page=1, cb) => async (dispatch) => {

    let error = null; 
    let res = null; 

    try {
    
        const { data } = await api.fetchFollowers(id, page);

        // dispatch({
        //     type: FETCH_FOLLOWING,
        //     payload: data
        // });

        res = data; 

    }catch (err) {

        console.log(err);

        error = err; 

    }

    if(typeof cb === 'function'){

        cb(error, res);
    }

}

//fetch user following
export const getUserFollowing = (id=null, page=1, cb) => async (dispatch) => {

    let error = null; 
    let res = null; 

    try {
    
        const { data } = await api.fetchFollowing(id, page);

        // dispatch({
        //     type: FETCH_FOLLOWING,
        //     payload: data
        // });

        res = data; 

    }catch (err) {

        console.log(err);

        error = err; 

    }

    if(typeof cb === 'function'){

        cb(error, res);
    }

    
}

//fetch suggested users
export const getSuggestedUsers = (id=null, page=1) => async (dispatch) => {

    try {

        const { data } = await api.fetchSuggestedUsers(id, page);

        dispatch({
            type: FETCH_SUGGESTED_USERS,
            payload: data
        });

    }catch (error) {

        console.log(error);
    }

    
}